console.log("PREMIUM KETJU MOOTTORI Configurator loading...");


// Hintamuutokset
const PRICE_ADJUSTMENTS = {
  euroAdjustment: 315,      // Euromääräinen lisäys/vähennys
  percentAdjustment: 0    // Prosentuaalinen lisäys/vähennys
};

// Määritä konfiguraatio
window.PremiumKetjuMoottoriProductConfig = {
  variantIds: {
    base: 51844704567634,
    adjustment: 51813495931218
  },
  dimensions: {
    minWidth: 700,
    maxWidth: 2200,
    minHeight: 200,
    maxHeight: 2600,
    maxArea: 5.75,
  },
  profiles: {
    white9016: { name: "Valkoinen RAL9016", color: "#FFFFFF" },
    white9016structure: {
      name: "Valkoinen RAL9016 structure",
      color: "#F8F8F8",
    },
    white9010structure: {
      name: "Valkoinen RAL9010 structure",
      color: "#F1F1F1",
    },
    creme9001structure: { name: "Creme RAL9001 structure", color: "#F6F0E7" },
    beige1015: { name: "Beige RAL1015", color: "#EBCC90" },
    bronzeAnodized: { name: "Pronssi anodisoitu", color: "#8E7C67" },
    silverAnodized: { name: "Hopea anodisoitu E6/EV1", color: "#EDEDED" },
    lightGray7040: {
      name: "Vaaleanharmaa RAL7040 structure",
      color: "#C0C0C0",
    },
    darkGrayDB703: { name: "Tummanharmaa DB 703", color: "#575556" },
    anthracite7016: { name: "Antrasiitti RAL7016 structure", color: "#3C3C3C" },
    black9005structure: { name: "Musta RAL9005 structure", color: "#0A0A0A" },
  },

  priceTable: {
    S: {
      700: {
        400: 193,
        500: 203,
        600: 213,
        700: 232,
        800: 247,
        900: 263,
        1000: 277,
        1100: 290,
        1200: 309,
        1300: 323,
        1400: 336,
        1500: 353,
        1600: 366,
        1700: 382,
        1800: 394,
        1900: 409,
        2000: 423,
        2100: 437,
        2200: 456,
      },
      800: {
        400: 195,
        500: 205,
        600: 217,
        700: 235,
        800: 249,
        900: 268,
        1000: 280,
        1100: 294,
        1200: 313,
        1300: 328,
        1400: 341,
        1500: 357,
        1600: 372,
        1700: 388,
        1800: 401,
        1900: 414,
        2000: 430,
        2100: 444,
        2200: 463,
      },
      900: {
        400: 198,
        500: 208,
        600: 220,
        700: 241,
        800: 255,
        900: 273,
        1000: 287,
        1100: 300,
        1200: 320,
        1300: 335,
        1400: 350,
        1500: 367,
        1600: 381,
        1700: 399,
        1800: 411,
        1900: 426,
        2000: 443,
        2100: 456,
        2200: 476,
      },
      1000: {
        400: 201,
        500: 212,
        600: 225,
        700: 245,
        800: 261,
        900: 279,
        1000: 293,
        1100: 307,
        1200: 327,
        1300: 343,
        1400: 357,
        1500: 376,
        1600: 390,
        1700: 408,
        1800: 423,
        1900: 438,
        2000: 454,
        2100: 469,
        2200: 489,
      },
      1100: {
        400: 205,
        500: 216,
        600: 229,
        700: 249,
        800: 265,
        900: 285,
        1000: 299,
        1100: 314,
        1200: 336,
        1300: 350,
        1400: 367,
        1500: 384,
        1600: 400,
        1700: 419,
        1800: 433,
        1900: 449,
        2000: 465,
        2100: 482,
        2200: 501,
      },
      1200: {
        400: 208,
        500: 219,
        600: 233,
        700: 255,
        800: 270,
        900: 289,
        1000: 305,
        1100: 320,
        1200: 343,
        1300: 359,
        1400: 376,
        1500: 393,
        1600: 409,
        1700: 429,
        1800: 444,
        1900: 460,
        2000: 477,
        2100: 493,
        2200: 515,
      },
      1300: {
        400: 212,
        500: 223,
        600: 238,
        700: 259,
        800: 275,
        900: 295,
        1000: 311,
        1100: 329,
        1200: 350,
        1300: 367,
        1400: 383,
        1500: 402,
        1600: 420,
        1700: 439,
        1800: 454,
        1900: 472,
        2000: 489,
        2100: 506,
        2200: 528,
      },
      1400: {
        400: 214,
        500: 226,
        600: 242,
        700: 263,
        800: 281,
        900: 301,
        1000: 317,
        1100: 334,
        1200: 357,
        1300: 375,
        1400: 393,
        1500: 410,
        1600: 428,
        1700: 449,
        1800: 466,
        1900: 483,
        2000: 501,
        2100: 519,
        2200: 541,
      },
      1500: {
        400: 218,
        500: 230,
        600: 245,
        700: 268,
        800: 285,
        900: 307,
        1000: 324,
        1100: 342,
        1200: 365,
        1300: 382,
        1400: 401,
        1500: 420,
        1600: 439,
        1700: 460,
        1800: 476,
        1900: 494,
        2000: 513,
        2100: 532,
        2200: 554,
      },
      1600: {
        400: 221,
        500: 233,
        600: 251,
        700: 274,
        800: 291,
        900: 312,
        1000: 330,
        1100: 349,
        1200: 372,
        1300: 390,
        1400: 409,
        1500: 428,
        1600: 447,
        1700: 470,
        1800: 488,
        1900: 505,
        2000: 526,
        2100: 542,
        2200: 566,
      },
      1700: {
        400: 225,
        500: 237,
        600: 255,
        700: 277,
        800: 297,
        900: 318,
        1000: 337,
        1100: 355,
        1200: 378,
        1300: 398,
        1400: 417,
        1500: 437,
        1600: 458,
        1700: 480,
        1800: 498,
        1900: 516,
        2000: 536,
        2100: 555,
        2200: 579,
      },
      1800: {
        400: 228,
        500: 240,
        600: 258,
        700: 282,
        800: 302,
        900: 323,
        1000: 343,
        1100: 362,
        1200: 386,
        1300: 407,
        1400: 427,
        1500: 447,
        1600: 466,
        1700: 491,
        1800: 508,
        1900: 528,
        2000: 548,
        2100: 568,
        2200: 593,
      },
      1900: {
        400: 231,
        500: 244,
        600: 262,
        700: 288,
        800: 307,
        900: 328,
        1000: 347,
        1100: 369,
        1200: 394,
        1300: 414,
        1400: 434,
        1500: 455,
        1600: 477,
        1700: 500,
        1800: 519,
        1900: 540,
        2000: 560,
        2100: 580,
        2200: 606,
      },
      2000: {
        400: 234,
        500: 247,
        600: 268,
        700: 291,
        800: 313,
        900: 335,
        1000: 354,
        1100: 376,
        1200: 402,
        1300: 422,
        1400: 443,
        1500: 465,
        1600: 486,
        1700: 511,
        1800: 530,
        1900: 551,
        2000: 573,
        2100: 592,
        2200: 619,
      },
      2100: {
        400: 238,
        500: 251,
        600: 271,
        700: 296,
        800: 317,
        900: 340,
        1000: 360,
        1100: 382,
        1200: 408,
        1300: 430,
        1400: 450,
        1500: 473,
        1600: 494,
        1700: 520,
        1800: 541,
        1900: 562,
        2000: 583,
        2100: 605,
        2200: 631,
      },
      2200: {
        400: 241,
        500: 254,
        600: 276,
        700: 301,
        800: 322,
        900: 347,
        1000: 366,
        1100: 388,
        1200: 416,
        1300: 438,
        1400: 460,
        1500: 484,
        1600: 505,
        1700: 531,
        1800: 551,
        1900: 574,
        2000: 596,
        2100: 618,
        2200: 644,
      },
      2300: {
        400: 245,
        500: 259,
        600: 279,
        700: 307,
        800: 328,
        900: 352,
        1000: 373,
        1100: 396,
        1200: 423,
        1300: 446,
        1400: 468,
        1500: 492,
        1600: 513,
        1700: 542,
        1800: 563,
        1900: 586,
        2000: 607,
        2100: 630,
        2200: 657,
      },
      2400: {
        400: 247,
        500: 262,
        600: 284,
        700: 310,
        800: 334,
        900: 356,
        1000: 379,
        1100: 402,
        1200: 431,
        1300: 454,
        1400: 476,
        1500: 501,
        1600: 524,
        1700: 551,
        1800: 572,
        1900: 596,
        2000: 619,
        2100: 643,
        2200: 671,
      },
      2500: {
        400: 251,
        500: 265,
        600: 288,
        700: 315,
        800: 339,
        900: 364,
        1000: 386,
        1100: 409,
        1200: 437,
        1300: 461,
        1400: 485,
        1500: 509,
        1600: 532,
        1700: 562,
        1800: 584,
        1900: 608,
        2000: 631,
        2100: 654,
        2200: 684,
      },
      2600: {
        400: 254,
        500: 269,
        600: 292,
        700: 321,
        800: 344,
        900: 368,
        1000: 391,
        1100: 416,
        1200: 445,
        1300: 469,
        1400: 494,
        1500: 519,
        1600: 543,
        1700: 572,
        1800: 595,
        1900: 619,
        2000: 642,
        2100: 666,
        2200: 696,
      },
      2700: {
        400: 258,
        500: 272,
        600: 297,
        700: 324,
        800: 349,
        900: 374,
        1000: 397,
        1100: 423,
        1200: 453,
        1300: 477,
        1400: 501,
        1500: 528,
        1600: 552,
        1700: 582,
        1800: 605,
        1900: 629,
        2000: 655,
        2100: 679,
        2200: 708,
      },
      2800: {
        400: 261,
        500: 277,
        600: 301,
        700: 329,
        800: 354,
        900: 380,
        1000: 404,
        1100: 429,
        1200: 461,
        1300: 485,
        1400: 511,
        1500: 537,
        1600: 561,
        1700: 592,
        1800: 616,
        1900: 641,
        2000: 666,
        2100: 692,
        2200: 722,
      },
    },
    0: {
      700: {
        400: 201,
        500: 212,
        600: 224,
        700: 244,
        800: 257,
        900: 277,
        1000: 291,
        1100: 305,
        1200: 325,
        1300: 341,
        1400: 354,
        1500: 371,
        1600: 386,
        1700: 403,
        1800: 417,
        1900: 431,
        2000: 446,
        2100: 462,
        2200: 482,
      },
      800: {
        400: 205,
        500: 214,
        600: 226,
        700: 246,
        800: 262,
        900: 282,
        1000: 294,
        1100: 310,
        1200: 331,
        1300: 345,
        1400: 361,
        1500: 377,
        1600: 393,
        1700: 411,
        1800: 424,
        1900: 439,
        2000: 455,
        2100: 470,
        2200: 490,
      },
      900: {
        400: 207,
        500: 216,
        600: 230,
        700: 251,
        800: 268,
        900: 287,
        1000: 301,
        1100: 317,
        1200: 338,
        1300: 355,
        1400: 369,
        1500: 388,
        1600: 402,
        1700: 421,
        1800: 436,
        1900: 451,
        2000: 468,
        2100: 484,
        2200: 506,
      },
      1000: {
        400: 211,
        500: 221,
        600: 236,
        700: 257,
        800: 272,
        900: 293,
        1000: 308,
        1100: 325,
        1200: 348,
        1300: 363,
        1400: 378,
        1500: 396,
        1600: 413,
        1700: 433,
        1800: 449,
        1900: 464,
        2000: 482,
        2100: 497,
        2200: 520,
      },
      1100: {
        400: 214,
        500: 226,
        600: 240,
        700: 262,
        800: 280,
        900: 300,
        1000: 315,
        1100: 332,
        1200: 355,
        1300: 371,
        1400: 388,
        1500: 407,
        1600: 425,
        1700: 445,
        1800: 459,
        1900: 476,
        2000: 495,
        2100: 510,
        2200: 533,
      },
      1200: {
        400: 218,
        500: 230,
        600: 244,
        700: 268,
        800: 284,
        900: 306,
        1000: 323,
        1100: 339,
        1200: 362,
        1300: 379,
        1400: 397,
        1500: 417,
        1600: 434,
        1700: 455,
        1800: 471,
        1900: 489,
        2000: 508,
        2100: 525,
        2200: 548,
      },
      1300: {
        400: 223,
        500: 234,
        600: 250,
        700: 274,
        800: 290,
        900: 312,
        1000: 328,
        1100: 347,
        1200: 371,
        1300: 389,
        1400: 408,
        1500: 427,
        1600: 445,
        1700: 466,
        1800: 484,
        1900: 502,
        2000: 520,
        2100: 539,
        2200: 562,
      },
      1400: {
        400: 226,
        500: 238,
        600: 255,
        700: 278,
        800: 297,
        900: 319,
        1000: 337,
        1100: 355,
        1200: 378,
        1300: 397,
        1400: 416,
        1500: 437,
        1600: 456,
        1700: 478,
        1800: 496,
        1900: 514,
        2000: 534,
        2100: 553,
        2200: 577,
      },
      1500: {
        400: 230,
        500: 243,
        600: 259,
        700: 283,
        800: 302,
        900: 325,
        1000: 343,
        1100: 363,
        1200: 388,
        1300: 407,
        1400: 426,
        1500: 447,
        1600: 466,
        1700: 488,
        1800: 508,
        1900: 527,
        2000: 547,
        2100: 566,
        2200: 591,
      },
      1600: {
        400: 233,
        500: 246,
        600: 263,
        700: 289,
        800: 309,
        900: 332,
        1000: 350,
        1100: 370,
        1200: 396,
        1300: 415,
        1400: 435,
        1500: 456,
        1600: 477,
        1700: 500,
        1800: 519,
        1900: 540,
        2000: 560,
        2100: 580,
        2200: 606,
      },
      1700: {
        400: 238,
        500: 250,
        600: 269,
        700: 294,
        800: 314,
        900: 338,
        1000: 357,
        1100: 377,
        1200: 403,
        1300: 424,
        1400: 444,
        1500: 467,
        1600: 487,
        1700: 512,
        1800: 531,
        1900: 553,
        2000: 574,
        2100: 594,
        2200: 620,
      },
      1800: {
        400: 241,
        500: 253,
        600: 273,
        700: 298,
        800: 320,
        900: 344,
        1000: 363,
        1100: 384,
        1200: 412,
        1300: 433,
        1400: 454,
        1500: 476,
        1600: 498,
        1700: 524,
        1800: 543,
        1900: 564,
        2000: 586,
        2100: 607,
        2200: 634,
      },
      1900: {
        400: 244,
        500: 257,
        600: 277,
        700: 304,
        800: 327,
        900: 349,
        1000: 371,
        1100: 392,
        1200: 419,
        1300: 442,
        1400: 463,
        1500: 487,
        1600: 508,
        1700: 534,
        1800: 555,
        1900: 577,
        2000: 599,
        2100: 621,
        2200: 650,
      },
      2000: {
        400: 247,
        500: 262,
        600: 283,
        700: 309,
        800: 331,
        900: 355,
        1000: 377,
        1100: 399,
        1200: 429,
        1300: 451,
        1400: 473,
        1500: 495,
        1600: 519,
        1700: 546,
        1800: 568,
        1900: 590,
        2000: 613,
        2100: 634,
        2200: 663,
      },
      2100: {
        400: 251,
        500: 265,
        600: 288,
        700: 314,
        800: 337,
        900: 361,
        1000: 385,
        1100: 408,
        1200: 436,
        1300: 459,
        1400: 482,
        1500: 505,
        1600: 530,
        1700: 558,
        1800: 580,
        1900: 602,
        2000: 626,
        2100: 648,
        2200: 677,
      },
      2200: {
        400: 256,
        500: 269,
        600: 291,
        700: 321,
        800: 343,
        900: 368,
        1000: 391,
        1100: 415,
        1200: 443,
        1300: 468,
        1400: 492,
        1500: 517,
        1600: 540,
        1700: 569,
        1800: 590,
        1900: 614,
        2000: 639,
        2100: 663,
        2200: 692,
      },
      2300: {
        400: 259,
        500: 273,
        600: 297,
        700: 325,
        800: 349,
        900: 374,
        1000: 397,
        1100: 423,
        1200: 453,
        1300: 476,
        1400: 501,
        1500: 526,
        1600: 551,
        1700: 579,
        1800: 603,
        1900: 627,
        2000: 651,
        2100: 677,
        2200: 706,
      },
      2400: {
        400: 263,
        500: 278,
        600: 302,
        700: 330,
        800: 355,
        900: 381,
        1000: 405,
        1100: 430,
        1200: 461,
        1300: 486,
        1400: 511,
        1500: 537,
        1600: 560,
        1700: 591,
        1800: 615,
        1900: 640,
        2000: 665,
        2100: 690,
        2200: 720,
      },
      2500: {
        400: 266,
        500: 282,
        600: 306,
        700: 336,
        800: 361,
        900: 387,
        1000: 411,
        1100: 437,
        1200: 469,
        1300: 494,
        1400: 519,
        1500: 546,
        1600: 572,
        1700: 602,
        1800: 628,
        1900: 653,
        2000: 678,
        2100: 703,
        2200: 735,
      },
      2600: {
        400: 271,
        500: 285,
        600: 310,
        700: 341,
        800: 367,
        900: 393,
        1000: 419,
        1100: 445,
        1200: 477,
        1300: 503,
        1400: 529,
        1500: 555,
        1600: 583,
        1700: 613,
        1800: 639,
        1900: 666,
        2000: 691,
        2100: 717,
        2200: 750,
      },
      2700: {
        400: 274,
        500: 289,
        600: 316,
        700: 345,
        800: 372,
        900: 400,
        1000: 425,
        1100: 451,
        1200: 484,
        1300: 512,
        1400: 539,
        1500: 566,
        1600: 592,
        1700: 625,
        1800: 650,
        1900: 678,
        2000: 705,
        2100: 731,
        2200: 764,
      },
      2800: {
        400: 277,
        500: 293,
        600: 321,
        700: 350,
        800: 379,
        900: 406,
        1000: 431,
        1100: 460,
        1200: 494,
        1300: 521,
        1400: 548,
        1500: 577,
        1600: 604,
        1700: 637,
        1800: 663,
        1900: 691,
        2000: 718,
        2100: 745,
        2200: 778,
      },
    },
    1: {
      700: {
        400: 206,
        500: 217,
        600: 235,
        700: 251,
        800: 274,
        900: 296,
        1000: 312,
        1100: 330,
        1200: 348,
        1300: 364,
        1400: 381,
        1500: 399,
        1600: 415,
        1700: 433,
        1800: 454,
        1900: 472,
        2000: 488,
        2100: 506,
        2200: 522,
      },
      800: {
        400: 208,
        500: 220,
        600: 238,
        700: 256,
        800: 280,
        900: 301,
        1000: 319,
        1100: 336,
        1200: 353,
        1300: 371,
        1400: 388,
        1500: 406,
        1600: 425,
        1700: 442,
        1800: 465,
        1900: 482,
        2000: 499,
        2100: 516,
        2200: 533,
      },
      900: {
        400: 213,
        500: 226,
        600: 243,
        700: 262,
        800: 287,
        900: 309,
        1000: 327,
        1100: 346,
        1200: 365,
        1300: 383,
        1400: 401,
        1500: 420,
        1600: 439,
        1700: 457,
        1800: 480,
        1900: 498,
        2000: 516,
        2100: 535,
        2200: 554,
      },
      1000: {
        400: 218,
        500: 231,
        600: 250,
        700: 269,
        800: 295,
        900: 319,
        1000: 337,
        1100: 356,
        1200: 375,
        1300: 395,
        1400: 415,
        1500: 434,
        1600: 453,
        1700: 472,
        1800: 497,
        1900: 516,
        2000: 534,
        2100: 554,
        2200: 573,
      },
      1100: {
        400: 224,
        500: 236,
        600: 256,
        700: 276,
        800: 302,
        900: 326,
        1000: 345,
        1100: 366,
        1200: 386,
        1300: 407,
        1400: 428,
        1500: 448,
        1600: 467,
        1700: 487,
        1800: 513,
        1900: 532,
        2000: 552,
        2100: 572,
        2200: 593,
      },
      1200: {
        400: 228,
        500: 240,
        600: 262,
        700: 282,
        800: 310,
        900: 335,
        1000: 354,
        1100: 377,
        1200: 398,
        1300: 420,
        1400: 441,
        1500: 461,
        1600: 481,
        1700: 504,
        1800: 530,
        1900: 549,
        2000: 572,
        2100: 591,
        2200: 613,
      },
      1300: {
        400: 233,
        500: 246,
        600: 269,
        700: 290,
        800: 318,
        900: 342,
        1000: 363,
        1100: 386,
        1200: 409,
        1300: 430,
        1400: 453,
        1500: 474,
        1600: 497,
        1700: 519,
        1800: 545,
        1900: 568,
        2000: 589,
        2100: 611,
        2200: 633,
      },
      1400: {
        400: 239,
        500: 252,
        600: 273,
        700: 296,
        800: 327,
        900: 352,
        1000: 373,
        1100: 397,
        1200: 421,
        1300: 442,
        1400: 466,
        1500: 488,
        1600: 511,
        1700: 534,
        1800: 562,
        1900: 584,
        2000: 607,
        2100: 630,
        2200: 653,
      },
      1500: {
        400: 244,
        500: 257,
        600: 279,
        700: 304,
        800: 334,
        900: 360,
        1000: 382,
        1100: 408,
        1200: 431,
        1300: 455,
        1400: 480,
        1500: 502,
        1600: 525,
        1700: 550,
        1800: 578,
        1900: 601,
        2000: 625,
        2100: 647,
        2200: 672,
      },
      1600: {
        400: 248,
        500: 263,
        600: 286,
        700: 310,
        800: 342,
        900: 368,
        1000: 391,
        1100: 417,
        1200: 442,
        1300: 467,
        1400: 493,
        1500: 517,
        1600: 540,
        1700: 565,
        1800: 595,
        1900: 619,
        2000: 642,
        2100: 666,
        2200: 692,
      },
      1700: {
        400: 253,
        500: 267,
        600: 292,
        700: 316,
        800: 349,
        900: 377,
        1000: 400,
        1100: 428,
        1200: 454,
        1300: 479,
        1400: 506,
        1500: 530,
        1600: 554,
        1700: 580,
        1800: 611,
        1900: 635,
        2000: 660,
        2100: 685,
        2200: 711,
      },
      1800: {
        400: 258,
        500: 272,
        600: 299,
        700: 324,
        800: 356,
        900: 385,
        1000: 409,
        1100: 437,
        1200: 466,
        1300: 490,
        1400: 518,
        1500: 544,
        1600: 569,
        1700: 597,
        1800: 627,
        1900: 652,
        2000: 679,
        2100: 704,
        2200: 732,
      },
      1900: {
        400: 263,
        500: 279,
        600: 304,
        700: 330,
        800: 366,
        900: 393,
        1000: 419,
        1100: 448,
        1200: 477,
        1300: 502,
        1400: 531,
        1500: 557,
        1600: 584,
        1700: 612,
        1800: 643,
        1900: 669,
        2000: 697,
        2100: 724,
        2200: 751,
      },
      2000: {
        400: 267,
        500: 284,
        600: 310,
        700: 338,
        800: 374,
        900: 401,
        1000: 428,
        1100: 458,
        1200: 487,
        1300: 514,
        1400: 544,
        1500: 571,
        1600: 597,
        1700: 628,
        1800: 660,
        1900: 686,
        2000: 714,
        2100: 742,
        2200: 771,
      },
      2100: {
        400: 273,
        500: 289,
        600: 317,
        700: 344,
        800: 381,
        900: 410,
        1000: 437,
        1100: 468,
        1200: 499,
        1300: 526,
        1400: 558,
        1500: 585,
        1600: 611,
        1700: 643,
        1800: 676,
        1900: 703,
        2000: 732,
        2100: 760,
        2200: 791,
      },
      2200: {
        400: 278,
        500: 295,
        600: 323,
        700: 350,
        800: 388,
        900: 419,
        1000: 445,
        1100: 477,
        1200: 510,
        1300: 538,
        1400: 571,
        1500: 598,
        1600: 626,
        1700: 658,
        1800: 692,
        1900: 720,
        2000: 751,
        2100: 779,
        2200: 811,
      },
      2300: {
        400: 283,
        500: 299,
        600: 330,
        700: 358,
        800: 396,
        900: 426,
        1000: 455,
        1100: 488,
        1200: 521,
        1300: 551,
        1400: 582,
        1500: 612,
        1600: 640,
        1700: 674,
        1800: 708,
        1900: 737,
        2000: 769,
        2100: 798,
        2200: 831,
      },
      2400: {
        400: 289,
        500: 305,
        600: 335,
        700: 364,
        800: 405,
        900: 436,
        1000: 465,
        1100: 497,
        1200: 532,
        1300: 561,
        1400: 595,
        1500: 625,
        1600: 656,
        1700: 690,
        1800: 725,
        1900: 754,
        2000: 788,
        2100: 816,
        2200: 850,
      },
      2500: {
        400: 293,
        500: 311,
        600: 341,
        700: 371,
        800: 413,
        900: 444,
        1000: 474,
        1100: 508,
        1200: 543,
        1300: 574,
        1400: 608,
        1500: 639,
        1600: 670,
        1700: 705,
        1800: 741,
        1900: 771,
        2000: 805,
        2100: 835,
        2200: 870,
      },
      2600: {
        400: 298,
        500: 316,
        600: 348,
        700: 379,
        800: 420,
        900: 452,
        1000: 483,
        1100: 517,
        1200: 554,
        1300: 586,
        1400: 621,
        1500: 652,
        1600: 684,
        1700: 721,
        1800: 756,
        1900: 787,
        2000: 823,
        2100: 855,
        2200: 889,
      },
      2700: {
        400: 303,
        500: 321,
        600: 354,
        700: 386,
        800: 428,
        900: 461,
        1000: 491,
        1100: 526,
        1200: 566,
        1300: 598,
        1400: 636,
        1500: 668,
        1600: 699,
        1700: 736,
        1800: 773,
        1900: 805,
        2000: 841,
        2100: 874,
        2200: 910,
      },
      2800: {
        400: 307,
        500: 326,
        600: 360,
        700: 393,
        800: 435,
        900: 469,
        1000: 501,
        1100: 539,
        1200: 578,
        1300: 610,
        1400: 647,
        1500: 680,
        1600: 714,
        1700: 751,
        1800: 789,
        1900: 821,
        2000: 858,
        2100: 891,
        2200: 930,
      },
    },
    2: {
      700: {
        400: 215,
        500: 229,
        600: 244,
        700: 268,
        800: 290,
        900: 312,
        1000: 333,
        1100: 351,
        1200: 373,
        1300: 391,
        1400: 414,
        1500: 432,
        1600: 454,
        1700: 471,
        1800: 492,
        1900: 510,
        2000: 532,
        2100: 549,
        2200: 572,
      },
      800: {
        400: 220,
        500: 232,
        600: 250,
        700: 274,
        800: 296,
        900: 319,
        1000: 341,
        1100: 359,
        1200: 383,
        1300: 400,
        1400: 424,
        1500: 441,
        1600: 465,
        1700: 483,
        1800: 505,
        1900: 523,
        2000: 546,
        2100: 564,
        2200: 587,
      },
      900: {
        400: 226,
        500: 238,
        600: 257,
        700: 282,
        800: 305,
        900: 331,
        1000: 354,
        1100: 372,
        1200: 397,
        1300: 415,
        1400: 441,
        1500: 459,
        1600: 485,
        1700: 503,
        1800: 525,
        1900: 545,
        2000: 568,
        2100: 587,
        2200: 613,
      },
      1000: {
        400: 232,
        500: 245,
        600: 266,
        700: 291,
        800: 316,
        900: 341,
        1000: 365,
        1100: 385,
        1200: 412,
        1300: 431,
        1400: 457,
        1500: 476,
        1600: 504,
        1700: 524,
        1800: 548,
        1900: 568,
        2000: 593,
        2100: 613,
        2200: 640,
      },
      1100: {
        400: 239,
        500: 252,
        600: 273,
        700: 299,
        800: 327,
        900: 353,
        1000: 378,
        1100: 398,
        1200: 425,
        1300: 447,
        1400: 474,
        1500: 495,
        1600: 523,
        1700: 544,
        1800: 569,
        1900: 590,
        2000: 615,
        2100: 637,
        2200: 666,
      },
      1200: {
        400: 245,
        500: 259,
        600: 282,
        700: 309,
        800: 336,
        900: 364,
        1000: 390,
        1100: 412,
        1200: 440,
        1300: 463,
        1400: 490,
        1500: 514,
        1600: 541,
        1700: 564,
        1800: 590,
        1900: 613,
        2000: 640,
        2100: 663,
        2200: 692,
      },
      1300: {
        400: 251,
        500: 266,
        600: 290,
        700: 320,
        800: 347,
        900: 374,
        1000: 403,
        1100: 425,
        1200: 455,
        1300: 479,
        1400: 508,
        1500: 532,
        1600: 560,
        1700: 584,
        1800: 613,
        1900: 636,
        2000: 662,
        2100: 687,
        2200: 719,
      },
      1400: {
        400: 258,
        500: 272,
        600: 298,
        700: 328,
        800: 356,
        900: 386,
        1000: 413,
        1100: 437,
        1200: 469,
        1300: 494,
        1400: 525,
        1500: 550,
        1600: 579,
        1700: 605,
        1800: 633,
        1900: 657,
        2000: 687,
        2100: 712,
        2200: 746,
      },
      1500: {
        400: 264,
        500: 279,
        600: 306,
        700: 337,
        800: 367,
        900: 398,
        1000: 426,
        1100: 451,
        1200: 483,
        1300: 510,
        1400: 541,
        1500: 567,
        1600: 599,
        1700: 625,
        1800: 654,
        1900: 681,
        2000: 711,
        2100: 737,
        2200: 772,
      },
      1600: {
        400: 271,
        500: 286,
        600: 315,
        700: 345,
        800: 377,
        900: 407,
        1000: 439,
        1100: 464,
        1200: 499,
        1300: 526,
        1400: 558,
        1500: 585,
        1600: 617,
        1700: 645,
        1800: 676,
        1900: 703,
        2000: 734,
        2100: 762,
        2200: 800,
      },
      1700: {
        400: 277,
        500: 293,
        600: 322,
        700: 355,
        800: 387,
        900: 419,
        1000: 451,
        1100: 478,
        1200: 513,
        1300: 541,
        1400: 574,
        1500: 603,
        1600: 636,
        1700: 665,
        1800: 697,
        1900: 726,
        2000: 758,
        2100: 786,
        2200: 825,
      },
      1800: {
        400: 283,
        500: 300,
        600: 331,
        700: 363,
        800: 397,
        900: 431,
        1000: 463,
        1100: 491,
        1200: 528,
        1300: 558,
        1400: 592,
        1500: 622,
        1600: 655,
        1700: 687,
        1800: 718,
        1900: 748,
        2000: 780,
        2100: 811,
        2200: 853,
      },
      1900: {
        400: 290,
        500: 308,
        600: 338,
        700: 374,
        800: 408,
        900: 441,
        1000: 475,
        1100: 504,
        1200: 542,
        1300: 573,
        1400: 608,
        1500: 639,
        1600: 674,
        1700: 707,
        1800: 740,
        1900: 771,
        2000: 805,
        2100: 836,
        2200: 880,
      },
      2000: {
        400: 296,
        500: 313,
        600: 347,
        700: 382,
        800: 418,
        900: 452,
        1000: 488,
        1100: 517,
        1200: 555,
        1300: 589,
        1400: 625,
        1500: 658,
        1600: 692,
        1700: 726,
        1800: 761,
        1900: 794,
        2000: 828,
        2100: 861,
        2200: 906,
      },
      2100: {
        400: 303,
        500: 321,
        600: 355,
        700: 391,
        800: 428,
        900: 464,
        1000: 500,
        1100: 530,
        1200: 570,
        1300: 605,
        1400: 641,
        1500: 676,
        1600: 712,
        1700: 746,
        1800: 782,
        1900: 817,
        2000: 852,
        2100: 887,
        2200: 933,
      },
      2200: {
        400: 309,
        500: 328,
        600: 363,
        700: 401,
        800: 439,
        900: 474,
        1000: 511,
        1100: 543,
        1200: 585,
        1300: 620,
        1400: 658,
        1500: 693,
        1600: 731,
        1700: 767,
        1800: 802,
        1900: 839,
        2000: 875,
        2100: 911,
        2200: 960,
      },
      2300: {
        400: 315,
        500: 333,
        600: 371,
        700: 409,
        800: 448,
        900: 486,
        1000: 524,
        1100: 557,
        1200: 599,
        1300: 637,
        1400: 674,
        1500: 712,
        1600: 750,
        1700: 787,
        1800: 825,
        1900: 862,
        2000: 900,
        2100: 936,
        2200: 986,
      },
      2400: {
        400: 322,
        500: 342,
        600: 380,
        700: 420,
        800: 459,
        900: 498,
        1000: 536,
        1100: 570,
        1200: 614,
        1300: 652,
        1400: 692,
        1500: 730,
        1600: 769,
        1700: 807,
        1800: 846,
        1900: 884,
        2000: 923,
        2100: 961,
        2200: 1013,
      },
      2500: {
        400: 327,
        500: 348,
        600: 387,
        700: 428,
        800: 468,
        900: 509,
        1000: 549,
        1100: 585,
        1200: 628,
        1300: 667,
        1400: 709,
        1500: 748,
        1600: 788,
        1700: 827,
        1800: 867,
        1900: 908,
        2000: 947,
        2100: 985,
        2200: 1040,
      },
      2600: {
        400: 335,
        500: 356,
        600: 396,
        700: 438,
        800: 479,
        900: 519,
        1000: 560,
        1100: 596,
        1200: 644,
        1300: 684,
        1400: 725,
        1500: 765,
        1600: 807,
        1700: 848,
        1800: 888,
        1900: 930,
        2000: 970,
        2100: 1011,
        2200: 1065,
      },
      2700: {
        400: 340,
        500: 362,
        600: 403,
        700: 446,
        800: 490,
        900: 531,
        1000: 573,
        1100: 609,
        1200: 658,
        1300: 699,
        1400: 742,
        1500: 783,
        1600: 827,
        1700: 868,
        1800: 910,
        1900: 951,
        2000: 994,
        2100: 1035,
        2200: 1093,
      },
      2800: {
        400: 346,
        500: 368,
        600: 413,
        700: 455,
        800: 499,
        900: 543,
        1000: 584,
        1100: 623,
        1200: 672,
        1300: 716,
        1400: 758,
        1500: 801,
        1600: 846,
        1700: 888,
        1800: 931,
        1900: 975,
        2000: 1018,
        2100: 1060,
        2200: 1120,
      },
    },
    3: {
      700: {
        400: 226,
        500: 238,
        600: 260,
        700: 283,
        800: 301,
        900: 334,
        1000: 348,
        1100: 372,
        1200: 396,
        1300: 418,
        1400: 441,
        1500: 463,
        1600: 487,
        1700: 510,
        1800: 531,
        1900: 547,
        2000: 568,
        2100: 592,
        2200: 620,
      },
      800: {
        400: 230,
        500: 244,
        600: 268,
        700: 290,
        800: 309,
        900: 342,
        1000: 359,
        1100: 382,
        1200: 405,
        1300: 429,
        1400: 453,
        1500: 476,
        1600: 499,
        1700: 524,
        1800: 547,
        1900: 563,
        2000: 586,
        2100: 611,
        2200: 639,
      },
      900: {
        400: 238,
        500: 251,
        600: 276,
        700: 301,
        800: 321,
        900: 355,
        1000: 374,
        1100: 398,
        1200: 424,
        1300: 448,
        1400: 474,
        1500: 499,
        1600: 524,
        1700: 549,
        1800: 572,
        1900: 591,
        2000: 615,
        2100: 640,
        2200: 671,
      },
      1000: {
        400: 245,
        500: 260,
        600: 286,
        700: 312,
        800: 334,
        900: 369,
        1000: 390,
        1100: 415,
        1200: 442,
        1300: 469,
        1400: 495,
        1500: 521,
        1600: 546,
        1700: 575,
        1800: 600,
        1900: 620,
        2000: 645,
        2100: 671,
        2200: 704,
      },
      1100: {
        400: 253,
        500: 267,
        600: 295,
        700: 324,
        800: 347,
        900: 382,
        1000: 405,
        1100: 431,
        1200: 461,
        1300: 488,
        1400: 515,
        1500: 544,
        1600: 571,
        1700: 598,
        1800: 627,
        1900: 648,
        2000: 675,
        2100: 703,
        2200: 736,
      },
      1200: {
        400: 260,
        500: 276,
        600: 305,
        700: 336,
        800: 359,
        900: 397,
        1000: 420,
        1100: 448,
        1200: 480,
        1300: 507,
        1400: 535,
        1500: 565,
        1600: 594,
        1700: 624,
        1800: 653,
        1900: 676,
        2000: 705,
        2100: 733,
        2200: 768,
      },
      1300: {
        400: 267,
        500: 284,
        600: 316,
        700: 345,
        800: 370,
        900: 408,
        1000: 436,
        1100: 464,
        1200: 497,
        1300: 527,
        1400: 556,
        1500: 587,
        1600: 618,
        1700: 649,
        1800: 680,
        1900: 705,
        2000: 734,
        2100: 764,
        2200: 801,
      },
      1400: {
        400: 274,
        500: 292,
        600: 324,
        700: 357,
        800: 383,
        900: 423,
        1000: 451,
        1100: 481,
        1200: 515,
        1300: 546,
        1400: 578,
        1500: 611,
        1600: 642,
        1700: 675,
        1800: 707,
        1900: 733,
        2000: 764,
        2100: 796,
        2200: 833,
      },
      1500: {
        400: 281,
        500: 300,
        600: 335,
        700: 369,
        800: 396,
        900: 437,
        1000: 465,
        1100: 497,
        1200: 534,
        1300: 567,
        1400: 598,
        1500: 632,
        1600: 665,
        1700: 698,
        1800: 732,
        1900: 761,
        2000: 793,
        2100: 827,
        2200: 864,
      },
      1600: {
        400: 290,
        500: 309,
        600: 343,
        700: 380,
        800: 409,
        900: 450,
        1000: 479,
        1100: 514,
        1200: 552,
        1300: 586,
        1400: 620,
        1500: 658,
        1600: 689,
        1700: 724,
        1800: 759,
        1900: 788,
        2000: 824,
        2100: 857,
        2200: 897,
      },
      1700: {
        400: 297,
        500: 316,
        600: 354,
        700: 390,
        800: 421,
        900: 464,
        1000: 495,
        1100: 530,
        1200: 570,
        1300: 605,
        1400: 640,
        1500: 678,
        1600: 712,
        1700: 750,
        1800: 785,
        1900: 817,
        2000: 854,
        2100: 889,
        2200: 929,
      },
      1800: {
        400: 305,
        500: 325,
        600: 363,
        700: 402,
        800: 434,
        900: 477,
        1000: 510,
        1100: 547,
        1200: 588,
        1300: 625,
        1400: 660,
        1500: 699,
        1600: 736,
        1700: 775,
        1800: 812,
        1900: 845,
        2000: 883,
        2100: 920,
        2200: 961,
      },
      1900: {
        400: 312,
        500: 332,
        600: 373,
        700: 413,
        800: 447,
        900: 490,
        1000: 525,
        1100: 563,
        1200: 607,
        1300: 644,
        1400: 682,
        1500: 723,
        1600: 758,
        1700: 800,
        1800: 839,
        1900: 873,
        2000: 914,
        2100: 949,
        2200: 994,
      },
      2000: {
        400: 320,
        500: 341,
        600: 383,
        700: 425,
        800: 460,
        900: 503,
        1000: 541,
        1100: 580,
        1200: 626,
        1300: 664,
        1400: 703,
        1500: 744,
        1600: 783,
        1700: 825,
        1800: 865,
        1900: 902,
        2000: 942,
        2100: 981,
        2200: 1026,
      },
      2100: {
        400: 327,
        500: 349,
        600: 391,
        700: 438,
        800: 473,
        900: 517,
        1000: 556,
        1100: 596,
        1200: 644,
        1300: 684,
        1400: 723,
        1500: 767,
        1600: 807,
        1700: 851,
        1800: 892,
        1900: 930,
        2000: 972,
        2100: 1012,
        2200: 1058,
      },
      2200: {
        400: 336,
        500: 357,
        600: 402,
        700: 446,
        800: 485,
        900: 531,
        1000: 571,
        1100: 613,
        1200: 661,
        1300: 703,
        1400: 744,
        1500: 789,
        1600: 830,
        1700: 875,
        1800: 919,
        1900: 958,
        2000: 1002,
        2100: 1042,
        2200: 1091,
      },
      2300: {
        400: 343,
        500: 365,
        600: 411,
        700: 458,
        800: 498,
        900: 544,
        1000: 587,
        1100: 629,
        1200: 680,
        1300: 722,
        1400: 765,
        1500: 811,
        1600: 854,
        1700: 900,
        1800: 945,
        1900: 985,
        2000: 1032,
        2100: 1074,
        2200: 1123,
      },
      2400: {
        400: 351,
        500: 374,
        600: 421,
        700: 469,
        800: 511,
        900: 558,
        1000: 602,
        1100: 646,
        1200: 698,
        1300: 743,
        1400: 787,
        1500: 833,
        1600: 878,
        1700: 925,
        1800: 972,
        1900: 1014,
        2000: 1061,
        2100: 1105,
        2200: 1155,
      },
      2500: {
        400: 357,
        500: 381,
        600: 432,
        700: 480,
        800: 524,
        900: 570,
        1000: 617,
        1100: 662,
        1200: 716,
        1300: 762,
        1400: 807,
        1500: 856,
        1600: 901,
        1700: 951,
        1800: 999,
        1900: 1043,
        2000: 1092,
        2100: 1136,
        2200: 1188,
      },
      2600: {
        400: 364,
        500: 390,
        600: 440,
        700: 491,
        800: 537,
        900: 584,
        1000: 633,
        1100: 679,
        1200: 734,
        1300: 782,
        1400: 827,
        1500: 879,
        1600: 925,
        1700: 976,
        1800: 1025,
        1900: 1072,
        2000: 1120,
        2100: 1167,
        2200: 1219,
      },
      2700: {
        400: 372,
        500: 397,
        600: 450,
        700: 502,
        800: 548,
        900: 597,
        1000: 648,
        1100: 695,
        1200: 753,
        1300: 801,
        1400: 849,
        1500: 901,
        1600: 948,
        1700: 1000,
        1800: 1053,
        1900: 1099,
        2000: 1150,
        2100: 1198,
        2200: 1251,
      },
      2800: {
        400: 379,
        500: 407,
        600: 460,
        700: 514,
        800: 561,
        900: 611,
        1000: 663,
        1100: 712,
        1200: 771,
        1300: 819,
        1400: 869,
        1500: 923,
        1600: 972,
        1700: 1026,
        1800: 1078,
        1900: 1127,
        2000: 1180,
        2100: 1229,
        2200: 1284,
      },
    },
    4: {
      700: {
        400: 243,
        500: 256,
        600: 281,
        700: 306,
        800: 325,
        900: 363,
        1000: 380,
        1100: 405,
        1200: 431,
        1300: 456,
        1400: 481,
        1500: 506,
        1600: 533,
        1700: 558,
        1800: 582,
        1900: 598,
        2000: 622,
        2100: 649,
        2200: 681,
      },
      800: {
        400: 247,
        500: 262,
        600: 289,
        700: 314,
        800: 335,
        900: 372,
        1000: 391,
        1100: 416,
        1200: 442,
        1300: 468,
        1400: 495,
        1500: 521,
        1600: 546,
        1700: 574,
        1800: 599,
        1900: 617,
        2000: 643,
        2100: 670,
        2200: 702,
      },
      900: {
        400: 256,
        500: 271,
        600: 298,
        700: 326,
        800: 348,
        900: 387,
        1000: 408,
        1100: 435,
        1200: 464,
        1300: 490,
        1400: 519,
        1500: 547,
        1600: 575,
        1700: 602,
        1800: 629,
        1900: 650,
        2000: 677,
        2100: 704,
        2200: 739,
      },
      1000: {
        400: 265,
        500: 281,
        600: 310,
        700: 340,
        800: 363,
        900: 403,
        1000: 426,
        1100: 454,
        1200: 484,
        1300: 515,
        1400: 544,
        1500: 573,
        1600: 600,
        1700: 632,
        1800: 660,
        1900: 683,
        2000: 711,
        2100: 740,
        2200: 777,
      },
      1100: {
        400: 274,
        500: 290,
        600: 320,
        700: 353,
        800: 378,
        900: 418,
        1000: 444,
        1100: 473,
        1200: 506,
        1300: 536,
        1400: 567,
        1500: 599,
        1600: 629,
        1700: 659,
        1800: 691,
        1900: 715,
        2000: 746,
        2100: 776,
        2200: 813,
      },
      1200: {
        400: 282,
        500: 299,
        600: 332,
        700: 367,
        800: 392,
        900: 435,
        1000: 461,
        1100: 492,
        1200: 528,
        1300: 558,
        1400: 590,
        1500: 624,
        1600: 656,
        1700: 689,
        1800: 721,
        1900: 748,
        2000: 780,
        2100: 812,
        2200: 850,
      },
      1300: {
        400: 290,
        500: 309,
        600: 344,
        700: 378,
        800: 405,
        900: 448,
        1000: 479,
        1100: 511,
        1200: 548,
        1300: 581,
        1400: 616,
        1500: 649,
        1600: 683,
        1700: 718,
        1800: 753,
        1900: 780,
        2000: 814,
        2100: 847,
        2200: 888,
      },
      1400: {
        400: 298,
        500: 318,
        600: 354,
        700: 391,
        800: 420,
        900: 467,
        1000: 497,
        1100: 530,
        1200: 568,
        1300: 603,
        1400: 639,
        1500: 676,
        1600: 710,
        1700: 748,
        1800: 784,
        1900: 813,
        2000: 848,
        2100: 883,
        2200: 925,
      },
      1500: {
        400: 307,
        500: 328,
        600: 366,
        700: 405,
        800: 435,
        900: 481,
        1000: 513,
        1100: 549,
        1200: 590,
        1300: 627,
        1400: 662,
        1500: 700,
        1600: 737,
        1700: 775,
        1800: 812,
        1900: 845,
        2000: 882,
        2100: 919,
        2200: 961,
      },
      1600: {
        400: 316,
        500: 337,
        600: 376,
        700: 417,
        800: 450,
        900: 496,
        1000: 529,
        1100: 568,
        1200: 610,
        1300: 649,
        1400: 687,
        1500: 726,
        1600: 765,
        1700: 804,
        1800: 843,
        1900: 877,
        2000: 917,
        2100: 954,
        2200: 999,
      },
      1700: {
        400: 324,
        500: 345,
        600: 388,
        700: 429,
        800: 464,
        900: 512,
        1000: 547,
        1100: 587,
        1200: 632,
        1300: 671,
        1400: 711,
        1500: 753,
        1600: 792,
        1700: 834,
        1800: 873,
        1900: 909,
        2000: 951,
        2100: 991,
        2200: 1036,
      },
      1800: {
        400: 334,
        500: 356,
        600: 399,
        700: 443,
        800: 478,
        900: 527,
        1000: 564,
        1100: 606,
        1200: 652,
        1300: 694,
        1400: 734,
        1500: 778,
        1600: 819,
        1700: 863,
        1800: 904,
        1900: 942,
        2000: 985,
        2100: 1026,
        2200: 1073,
      },
      1900: {
        400: 342,
        500: 364,
        600: 410,
        700: 455,
        800: 493,
        900: 542,
        1000: 582,
        1100: 625,
        1200: 674,
        1300: 715,
        1400: 758,
        1500: 805,
        1600: 845,
        1700: 891,
        1800: 936,
        1900: 974,
        2000: 1020,
        2100: 1060,
        2200: 1111,
      },
      2000: {
        400: 351,
        500: 374,
        600: 422,
        700: 468,
        800: 508,
        900: 557,
        1000: 600,
        1100: 644,
        1200: 696,
        1300: 738,
        1400: 782,
        1500: 829,
        1600: 873,
        1700: 920,
        1800: 965,
        1900: 1007,
        2000: 1052,
        2100: 1096,
        2200: 1147,
      },
      2100: {
        400: 360,
        500: 383,
        600: 431,
        700: 482,
        800: 523,
        900: 573,
        1000: 617,
        1100: 663,
        1200: 716,
        1300: 761,
        1400: 805,
        1500: 855,
        1600: 900,
        1700: 950,
        1800: 997,
        1900: 1039,
        2000: 1086,
        2100: 1132,
        2200: 1184,
      },
      2200: {
        400: 369,
        500: 393,
        600: 443,
        700: 493,
        800: 537,
        900: 589,
        1000: 635,
        1100: 682,
        1200: 737,
        1300: 783,
        1400: 830,
        1500: 881,
        1600: 927,
        1700: 978,
        1800: 1028,
        1900: 1072,
        2000: 1122,
        2100: 1167,
        2200: 1223,
      },
      2300: {
        400: 377,
        500: 402,
        600: 454,
        700: 506,
        800: 552,
        900: 604,
        1000: 653,
        1100: 701,
        1200: 758,
        1300: 805,
        1400: 854,
        1500: 906,
        1600: 954,
        1700: 1007,
        1800: 1058,
        1900: 1103,
        2000: 1156,
        2100: 1204,
        2200: 1258,
      },
      2400: {
        400: 387,
        500: 412,
        600: 465,
        700: 520,
        800: 567,
        900: 620,
        1000: 670,
        1100: 720,
        1200: 779,
        1300: 829,
        1400: 879,
        1500: 931,
        1600: 982,
        1700: 1035,
        1800: 1089,
        1900: 1136,
        2000: 1189,
        2100: 1239,
        2200: 1295,
      },
      2500: {
        400: 393,
        500: 420,
        600: 477,
        700: 532,
        800: 582,
        900: 634,
        1000: 688,
        1100: 739,
        1200: 799,
        1300: 851,
        1400: 902,
        1500: 958,
        1600: 1009,
        1700: 1065,
        1800: 1120,
        1900: 1170,
        2000: 1225,
        2100: 1274,
        2200: 1333,
      },
      2600: {
        400: 402,
        500: 431,
        600: 487,
        700: 544,
        800: 596,
        900: 650,
        1000: 706,
        1100: 758,
        1200: 821,
        1300: 874,
        1400: 925,
        1500: 984,
        1600: 1036,
        1700: 1093,
        1800: 1150,
        1900: 1202,
        2000: 1257,
        2100: 1311,
        2200: 1370,
      },
      2700: {
        400: 411,
        500: 439,
        600: 499,
        700: 558,
        800: 610,
        900: 665,
        1000: 723,
        1100: 777,
        1200: 842,
        1300: 896,
        1400: 951,
        1500: 1010,
        1600: 1063,
        1700: 1122,
        1800: 1181,
        1900: 1233,
        2000: 1291,
        2100: 1346,
        2200: 1406,
      },
      2800: {
        400: 419,
        500: 450,
        600: 510,
        700: 571,
        800: 625,
        900: 682,
        1000: 741,
        1100: 796,
        1200: 863,
        1300: 917,
        1400: 974,
        1500: 1035,
        1600: 1090,
        1700: 1152,
        1800: 1211,
        1900: 1266,
        2000: 1326,
        2100: 1381,
        2200: 1444,
      },
    },
  },
};

document.addEventListener("DOMContentLoaded", function () {
  const config = window.PremiumKetjuMoottoriProductConfig;
  let selectedFabricGroup = null;
  let selectedProfile = null;
  let widthInput, heightInput, profileStep, priceDisplay, calculatedPrice;

  // Piilota alkuperäinen ostoskoriin-nappi heti
  setTimeout(function () {
    const originalButton = document.querySelector('button[name="add"]');

    if (originalButton) {
      originalButton.style.position = "absolute";
      originalButton.style.left = "-9999px";
      originalButton.style.visibility = "hidden";
      console.log("Original button hidden on page load");
    }
  }, 100);

  // Odota että DOM on valmis, sitten luo elementit
  setTimeout(function () {
    console.log("Calling createPremiumKetjuMoottoriElements...");
    createPremiumKetjuMoottoriElements();

    // Tunnista oletuskangasväri sivun latautuessa
    const fabricSelect = document.querySelector(
      'select[name="options[KANGAS]"]'
    );
    if (fabricSelect && fabricSelect.selectedIndex >= 0) {
      const selectedOption = fabricSelect.options[fabricSelect.selectedIndex];
      const variantTitle = selectedOption.text;
      const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
      if (groupMatch) {
        selectedFabricGroup = groupMatch[1];
        console.log("Initial fabric group detected:", selectedFabricGroup);

        if (profileStep) {
          profileStep.classList.remove("disabled");
          profileStep.classList.add("active");
          createProfileOptions();
        }
      }
    }

    // Kangasvärin valinta
    if (fabricSelect) {
      fabricSelect.addEventListener("change", function () {
        const selectedOption = this.options[this.selectedIndex];
        const variantTitle = selectedOption.text;

        const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
        if (groupMatch) {
          selectedFabricGroup = groupMatch[1];
          console.log("Selected fabric group:", selectedFabricGroup);

          if (profileStep) {
            profileStep.classList.remove("disabled");
            profileStep.classList.add("active");
            createProfileOptions();
          }
          calculatePrice();
        }
      });
    }
  }, 300);

  function createPremiumKetjuMoottoriElements() {
  const productForm =
    document.querySelector(".product-form") ||
    document.querySelector(".product__info-wrapper") ||
    document.body;

  // Luo pääkontaineri
  let configurator = document.getElementById("premium-ketju-moottori-configurator");
  if (!configurator) {
    configurator = document.createElement("div");
    configurator.id = "premium-ketju-moottori-configurator";
    configurator.className = "premium-ketju-moottori-configurator";
    productForm.appendChild(configurator);
  }

    // Luo mittakentät
    if (!document.getElementById("width-input")) {
      const dimensionsDiv = document.createElement("div");
      dimensionsDiv.className = "config-step active";

      dimensionsDiv.innerHTML = `
            <h3>Syötä mitat (mm)</h3>
            <div class="dimension-inputs">
                <div class="input-group">
                    <label>Leveys</label>
                    <input placeholder="esim. 1400" max="2200" min="700" id="width-input" type="number">
                    <div id="width-validation" class="validation-message"></div>
                </div>
                <div class="input-group">
                    <label>Korkeus</label>
                    <input placeholder="esim. 1800" max="2600" min="200" id="height-input" type="number">
                    <div id="height-validation" class="validation-message"></div>
                </div>
            </div>
        `;

      configurator.appendChild(dimensionsDiv);
    }

    // Luo profiiliväri-osio
    if (!document.getElementById("profile-step")) {
      const profileDiv = document.createElement("div");
      profileDiv.id = "profile-step";
      profileDiv.className = "config-step disabled";
      profileDiv.innerHTML = `
            <h3>Valitse profiiliväri</h3>
            <div id="profile-options"></div>
        `;
      configurator.appendChild(profileDiv);
    }

    // Luo hinta-osio
    if (!document.getElementById("price-display")) {
      const priceDiv = document.createElement("div");
      priceDiv.id = "price-display";
      priceDiv.className = "config-step price-display";
      priceDiv.style.display = "none";
      priceDiv.innerHTML = `
            <h3>Hinta</h3>
            <div style="font-size: 2rem; font-weight: bold; color: #ffffff; margin-bottom: 15px;" id="calculated-price"></div>
        `;
      configurator.appendChild(priceDiv);
    }

    // Päivitä elementtiviittaukset
    widthInput = document.getElementById("width-input");
    heightInput = document.getElementById("height-input");
    profileStep = document.getElementById("profile-step");
    priceDisplay = document.getElementById("price-display");
    calculatedPrice = document.getElementById("calculated-price");
  }

  function getProfilesForProduct() {
    const productHandle = window.location.pathname;

    // Jos ALL-BLACK tai MUSTA tuote - vain musta profiili
    if (
      productHandle.includes("all-black") ||
      productHandle.includes("musta")
    ) {
      return {
        anthracite: {
          name: "Musta RAL9005 structure",
          color: "#0A0A0A",
        },
      };
    }

    // Muuten kaikki normaalit PREMIUM profiilit
    return config.profiles;
  }

  function createProfileOptions() {
    const profileOptions = document.getElementById("profile-options");
    if (!profileOptions) return;

    const customDropdown = document.createElement("div");
    customDropdown.className = "custom-dropdown";

    const selected = document.createElement("div");
    selected.className = "dropdown-selected";

    selected.innerHTML = `
    <span>Valitse profiiliväri</span>
    <span class="dropdown-arrow">▼</span>
`;

    const options = document.createElement("div");
    options.className = "dropdown-options";

    // Lisää profiilivärit
    Object.keys(getProfilesForProduct()).forEach(function (key) {
      const profile = getProfilesForProduct()[key];

      const option = document.createElement("div");
      option.className = "dropdown-option";

      option.innerHTML = `
    <span class="profile-color-icon" style="background-color: ${profile.color};"></span>
    <span class="profile-option-text">${profile.name}</span>
  `;

      option.addEventListener("click", function () {
        selectedProfile = key;
        selected.innerHTML = `
      <span class="dropdown-selected-content">
        <span class="profile-color-icon" style="background-color: ${profile.color};"></span>
        ${profile.name}
      </span>
      <span class="dropdown-arrow">▼</span>
    `;

        options.classList.remove("show");
        calculatePrice();
      });

      options.appendChild(option);
    });

    selected.addEventListener("click", function () {
      options.classList.toggle("show");
    });

    customDropdown.appendChild(selected);
    customDropdown.appendChild(options);

    profileOptions.innerHTML = "";
    profileOptions.appendChild(customDropdown);
  }

  function calculatePrice() {
    console.log("calculatePrice called");
    const width = parseInt(widthInput?.value) || 0;
    const height = parseInt(heightInput?.value) || 0;

    // Tarkista validointi ensin
    if (!updateFieldValidation()) {
      console.log("Validation failed");
      // Näytä lähtöhinta vaikka validointi epäonnistui (Google-vaatimus)
      if (priceDisplay) priceDisplay.style.display = "block";
      if (calculatedPrice) calculatedPrice.textContent = "Alkaen 647.00 €";
      return;
    }

    // Tarkista että profiiliväri on valittu
    if (!selectedProfile) {
      console.log("No profile selected");
      // Näytä lähtöhinta vaikka profiilia ei valittu (Google-vaatimus)
      if (priceDisplay) priceDisplay.style.display = "block";
      if (calculatedPrice) calculatedPrice.textContent = "Alkaen 647.00 €";
      return;
    }

    console.log("Current values:", {
      width: width,
      height: height,
      selectedFabricGroup: selectedFabricGroup,
      selectedProfile: selectedProfile,
    });

    if (
      width > 0 &&
      height > 0 &&
      selectedFabricGroup &&
      config.priceTable[selectedFabricGroup]
    ) {
      const normalizedWidth = Math.min(
        Math.max(Math.ceil(width / 100) * 100, 400),
        2300
      );
      const normalizedHeight = Math.min(
        Math.max(Math.ceil(height / 100) * 100, 700),
        2700
      );

      console.log(
        "Normalized dimensions:",
        normalizedWidth,
        "x",
        normalizedHeight
      );

      const priceData = config.priceTable[selectedFabricGroup];
      let basePrice = null;

      if (priceData[normalizedHeight]) {
        if (priceData[normalizedHeight][normalizedWidth]) {
          basePrice = priceData[normalizedHeight][normalizedWidth];
          console.log("Price found:", basePrice);
        } else {
          // B-hinnoittelu: etsi lähin pienempi leveys
          for (let w = normalizedWidth - 100; w >= 400; w -= 100) {
            if (priceData[normalizedHeight][w]) {
              basePrice = priceData[normalizedHeight][w];
              console.log("B-pricing: Found price", basePrice, "at width", w);
              break;
            }
          }
          if (!basePrice) basePrice = 646.0;
        }
      } else {
        // B-hinnoittelu: etsi lähin pienempi korkeus
        for (let h = normalizedHeight - 100; h >= 700; h -= 100) {
          if (priceData[h] && priceData[h][normalizedWidth]) {
            basePrice = priceData[h][normalizedWidth];
            console.log("B-pricing: Found price", basePrice, "at height", h);
            break;
          }
        }
        if (!basePrice) basePrice = 646.0;
      }

      if (calculatedPrice && basePrice) {
        // 1. Lisää euromääräinen muutos
        let priceAfterEuro = basePrice + PRICE_ADJUSTMENTS.euroAdjustment;
        console.log("After euro adjustment:", priceAfterEuro);
        
        // 2. Lisää prosentuaalinen muutos
        let priceAfterPercent = priceAfterEuro * (1 + PRICE_ADJUSTMENTS.percentAdjustment / 100);
        console.log("After percent adjustment:", priceAfterPercent);
        
        // 3. Pyöristä lähimpään tasaeuroon
        let roundedPrice = Math.round(priceAfterPercent);
        console.log("After rounding:", roundedPrice);
        
        // 4. Varmista minimihinta 646 €
        const finalPrice = Math.max(roundedPrice, 646);
        console.log("Final price:", finalPrice);
        
        calculatedPrice.textContent = finalPrice.toFixed(2) + " €";
      }
      if (priceDisplay) {
        priceDisplay.style.display = "block";
      }

      // Lisää ostoskoriin-nappi
      createAddToCartButton();
    } else {
      console.log("Conditions not met for price calculation");
      if (priceDisplay) priceDisplay.style.display = "none";
    }
  }

  function validateDimensions(width, height) {
    const errors = {};
    const messages = {};

    if (width < 700) {
      errors.width = true;
      messages.width = "Min 700mm";
    } else if (width > 2200) {
      errors.width = true;
      messages.width = "Max 2200mm";
    }

    if (height < 200) {
      errors.height = true;
      messages.height = "Min 200mm";
    } else if (height > 2600) {
      errors.height = true;
      messages.height = "Max 2600mm";
    }

    if (width * height > 5750000) {
      errors.width = true;
      errors.height = true;
      messages.width = "Max 5,75 m²";
      messages.height = "Max 5,75 m²";
    }

    return { errors, messages };
  }

  function updateFieldValidation() {
    const width = parseInt(widthInput?.value) || 0;
    const height = parseInt(heightInput?.value) || 0;

    if (width > 0 && height > 0) {
      const validation = validateDimensions(width, height);

      // Käytä CSS-luokkia inline-tyylien sijaan
      const widthValidation = document.getElementById("width-validation");
      const heightValidation = document.getElementById("height-validation");

      if (validation.errors.width) {
        widthInput.style.borderColor = "#ff6b6b";
        if (widthValidation) {
          widthValidation.textContent = validation.messages.width;
          widthValidation.className = "validation-message error";
        }
      } else {
        widthInput.style.borderColor = "#333";
        if (widthValidation) {
          widthValidation.textContent = "";
          widthValidation.className = "validation-message";
        }
      }

      if (validation.errors.height) {
        heightInput.style.borderColor = "#ff6b6b";
        if (heightValidation) {
          heightValidation.textContent = validation.messages.height;
          heightValidation.className = "validation-message error";
        }
      } else {
        heightInput.style.borderColor = "#333";
        if (heightValidation) {
          heightValidation.textContent = "";
          heightValidation.className = "validation-message";
        }
      }

      if (validation.errors.width || validation.errors.height) {
        if (priceDisplay) priceDisplay.style.display = "none";
        return false;
      }
    }

    return true;
  }

  function createAddToCartButton() {
  // Tarkista onko nappi jo olemassa
  let existingButton = document.getElementById("premium-ketju-moottori-add-to-cart");
  if (existingButton) {
    existingButton.style.display = "block";
    return;
  }

  // Luo uusi nappi
  const addToCartButton = document.createElement("button");
  addToCartButton.id = "premium-ketju-moottori-add-to-cart";
  addToCartButton.type = "button";
  addToCartButton.textContent = "Lisää ostoskoriin";
  addToCartButton.className = "premium-add-to-cart-button";

  // UUSI: Cart API -pohjainen lisäys
  addToCartButton.addEventListener("click", function () {
    // Kerää tiedot
    const width = parseInt(widthInput.value);
    const height = parseInt(heightInput.value);
    const calculatedPriceValue = parseFloat(calculatedPrice.textContent.replace(' €', '').replace(',', '.'));
    const profileName = getProfilesForProduct()[selectedProfile].name;
    
    // Hae kangasväri
    const fabricSelect = document.querySelector('select[name="options[KANGAS]"]');
    const fabricOption = fabricSelect ? fabricSelect.options[fabricSelect.selectedIndex].text : 'Ei valittu';
    
    // Perustuotteen hinta
    const basePrice = 647.00;
    
    // Laske korotus
    const priceAdjustment = calculatedPriceValue - basePrice;
    
    // Luo unique ID tälle tuoteparille
    const pairId = Date.now().toString();
    
    // Valmistele Cart API -kutsu (käänteisessä järjestyksessä)
    const formData = {
      items: []
    };
    
    // Lisää räätälöinti AINA (jos hinta > 0)
    const adjustmentQuantity = Math.max(1, Math.round(priceAdjustment));
    
    formData.items.push({
      id: config.variantIds.adjustment,
      quantity: adjustmentQuantity,
      properties: {
        'Kangasväri': fabricOption,
        'Mitat': `${width}×${height} mm`,
        'Profiiliväri': profileName,
        '_pair_id': pairId,
        '_pair_order': '2'
      }
    });
    
    // Lisää perustuote TOISENA
    formData.items.push({
      id: config.variantIds.base,
      quantity: 1,
      properties: {
        '_pair_id': pairId,
        '_pair_order': '1'
      }
    });
    
    // Lähetä Cart API:lle
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Success:', data);
      // Päivitä ostoskori
      window.location.href = '/cart';
    })
    .catch((error) => {
      console.error('Error:', error);
      alert('Lisääminen ostoskoriin epäonnistui. Yritä uudelleen.');
    });
  });

  // Lisää hinta-osion jälkeen
  if (priceDisplay) {
    priceDisplay.appendChild(addToCartButton);
  }
  
  console.log("Add to cart button created");
}

  // Varmista hinnan päivitys kaikissa tilanteissa
  let lastValues = {
    width: "",
    height: "",
    fabric: "",
    profile: "",
  };

  function checkForChanges() {
    const currentWidth = widthInput?.value || "";
    const currentHeight = heightInput?.value || "";
    const currentFabric =
      document.querySelector('select[name="options[KANGAS]"]')?.value || "";
    const currentProfile = selectedProfile || "";

    if (
      currentWidth !== lastValues.width ||
      currentHeight !== lastValues.height ||
      currentFabric !== lastValues.fabric ||
      currentProfile !== lastValues.profile
    ) {
      console.log("Change detected, updating price...");

      // Päivitä kangasryhmä jos tarpeen
      if (currentFabric !== lastValues.fabric) {
        const fabricSelect = document.querySelector(
          'select[name="options[KANGAS]"]'
        );
        if (fabricSelect) {
          const selectedOption =
            fabricSelect.options[fabricSelect.selectedIndex];
          const variantTitle = selectedOption.text;
          const groupMatch = variantTitle.match(/\(([^)]+)\)[^(]*$/);
          if (groupMatch) {
            selectedFabricGroup = groupMatch[1];
            console.log("Updated fabric group:", selectedFabricGroup);
          }
        }
      }

      calculatePrice();

      lastValues.width = currentWidth;
      lastValues.height = currentHeight;
      lastValues.fabric = currentFabric;
      lastValues.profile = currentProfile;
    }
  }

  function updateAreaDisplay(width, height) {
    console.log("updateAreaDisplay called with:", width, height);

    const areaValueElement = document.getElementById("area-value");
    const areaDisplayElement = document.getElementById("area-display");

    console.log("Area value element:", areaValueElement);
    console.log("Area display element:", areaDisplayElement);

    if (!areaValueElement) {
      console.log("ERROR: area-value element not found!");
      return;
    }

    if (width > 0 && height > 0) {
      const area = ((width * height) / 1000000).toFixed(2);
      console.log("Calculated area:", area);

      areaValueElement.textContent = area + " m²";
      console.log("Area text updated to:", areaValueElement.textContent);

      // Muuta väri jos ylittää 5,75 m²
      if (parseFloat(area) > 5.75) {
        areaValueElement.style.color = "red";
        console.log("Area color set to red");
      } else {
        areaValueElement.style.color = "#dfa408";
        console.log("Area color set to green");
      }
    } else {
      areaValueElement.textContent = "- m²";
      areaValueElement.style.color = "white";
      console.log("Area reset to default");
    }
  }

  // Tarkista muutokset 500ms välein
  setInterval(checkForChanges, 500);
});
